import ProductTileComponent from '../../product-list/product-tile/product-tile.component';
import { memo } from 'react';
import productCarouselFactory from './product-carousel-factory';

const ProductCarouselComponent = productCarouselFactory(ProductTileComponent);

export default memo(ProductCarouselComponent);
